module.exports = __webpack_public_path__ + "img/b7.09f37fa0.jpg";